import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { SurgeryKitMissingItemDTO } from '../../interface/surgery';

type SurgeryKitMissingItemsDialogProps = {
    visible: boolean;
    items: SurgeryKitMissingItemDTO[];
    onHide: () => void;
    onApply: () => void;
};

export default function SurgeryKitMissingItemsDialog({
    visible,
    items,
    onHide,
    onApply,
}: SurgeryKitMissingItemsDialogProps) {
    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header="Insumos sin stock suficiente"
            modal
            style={{ width: 'min(900px, 95vw)' }}
            closable
            draggable={false}
            resizable={false}
            footer={(
                <div className="flex justify-end gap-2">
                    <Button
                        label="Cancelar"
                        icon="pi pi-times"
                        className="buttonMain3"
                        onClick={onHide}
                    />
                    <Button
                        label="Aplicar de todas formas"
                        icon="pi pi-check"
                        className="buttonMain"
                        onClick={onApply}
                    />
                </div>
            )}
        >
            <p className="mb-3">
                Algunos insumos del kit no tienen stock suficiente. Si continuás, se agregará sólo la parte disponible.
            </p>
            <DataTable
                value={items}
                emptyMessage="No hay insumos faltantes."
                size="small"
                className="surgery-table"
                scrollable
                scrollHeight="260px"
            >
                <Column field="description" header="Insumo" style={{ minWidth: '280px' }} />
                <Column field="requiredQuantity" header="Requerido" style={{ width: '130px', textAlign: 'center' }} />
                <Column field="availableQuantity" header="Disponible" style={{ width: '130px', textAlign: 'center' }} />
                <Column field="missingQuantity" header="Faltante" style={{ width: '130px', textAlign: 'center' }} />
            </DataTable>
        </Dialog>
    );
}
